<!--
MenuUser component
The menu content for the User menu list
-->
<template>
    <div class="dropdown p-1 navbar-toolbar" style="width: auto;">
        <button href="#" class="btn dropdown-toggle d-flex align-items-center" data-toggle="dropdown" role="button" aria-expanded="false">
            <i class="fas fa-user-circle fa-2x mr-1"></i> {{user.name}}<span class="caret"></span>
        </button>
        <ul class="dropdown-menu" role="menu">
            <template v-if="user.is_admin">
                <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/admin">
                    <span class="fa fa-tools dropdown-menu-icon" aria-hidden="true" style="display: flex" >&nbsp;</span>Admin Dashboard</a>
            </li>
            </template>
            <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/home">
                    <span class="fa fa-desktop dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Dashboard</a>
            </li>
           <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/grid">
                    <span class="fa fa-table dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Pricing Grid</a>
            </li>
            <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/resources">
                    <span class="fa fa-video dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Resources</a>
            </li>
            <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/documentation">
                    <span class="fa fa-book dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Documentation</a>
            </li>
            <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/security">
                    <span class="fa fa-key dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Security</a>
            </li>
            <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="/about">
                    <span class="fa fa-info-circle dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>About</a>
            </li>
            <li class="dropdown-menu-item">
                <a class="dropdown-menu-item" href="#" @click="logout">
                    <span class="fa fa-lock-open dropdown-menu-icon" aria-hidden="true" >&nbsp;</span>Logout</a>
            </li>
        </ul>
<!--        <form id="logout-form" action="{{ route('logout') }}" method="POST" style="display: none;">-->
<!--            @csrf-->
<!--        </form>-->
    </div>
</template>
<script>
    export default {
        /**
         * The component's properties.
         */
        props: {
            guest: {required: true},
            user: {required: true},
            showReports: {required: true, type: Boolean, default: false}
        },
        data () {
            return {
            }
        },
        computed: {
        },
            methods: {
            logout(e) {
                e.preventDefault();
                document.getElementById('logout-form').submit()
            }
        },
    }
</script>
